<template>
  <div>
    <el-select v-model="value" placeholder="请选择标签" v-loadmore="loadmoreConfig" clearable>
      <el-option v-for="item in options" :key="item.id" :label="item.tagName" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  watch: {
    value: {
      handler(val) {
        this.$emit("byTags", val);
      },
      immediate: true
    }
  },
  created () {
    this.getTags();
  },
  computed: {
    pageConfig() {
      return {
        from: this.tagsPage.current + 1,
        size: this.tagsPage.size,
        conditions: []
      }
    }
  },
  data() {
    return {
      value: "",
      options: [],
      loadmoreConfig: {
        loadmore: this.loadMoreTags,
        className: "el-select-dropdown__wrap"
      },
      tagsPage: {
        current: 0,
        total: 0,
        size: 10,
        pages:0
      }
    };
  },
  methods: {
    getTags(){
      this.$api.getTags(this.pageConfig).then(res => {
        this.options = this.options.concat(res.records);
        this.tagsPage = {
          current: res.current,
          total: res.total,
          size: res.size,
          pages: res.pages
        }
      })
    },
    loadMoreTags() {
      if (this.tagsPage.current >= this.tagsPage.pages) {
        return;
      }
      this.getTags();
    }
  }
};
</script>

<style>
</style>